<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const stateOptions = [
  {
    name: 'activated',
    label: t('AGENT_MGMT.STATE_OPTIONS.ACTIVATED'),
    value: true,
  },
  {
    name: 'disabled',
    label: t('AGENT_MGMT.STATE_OPTIONS.DISABLED'),
    value: false,
  },
];

const selectedValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', newValue);
  },
});
</script>

<template>
  <div class="w-full">
    <label>
      {{ label }}
      <select v-model="selectedValue">
        <option
          v-for="option in stateOptions"
          :key="option.name"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </label>
  </div>
</template>
